import { useRef, useCallback } from "react";

const useInfiniteScroll = (fetchNextPage, hasNextPage, isFetchingNextPage) => {
  const observerRef = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (isFetchingNextPage) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasNextPage) {
            fetchNextPage();
          }
        },
        { threshold: 0.5 }
      );

      if (node) observerRef.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  return lastElementRef;
};

export default useInfiniteScroll;
